import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import { render } from 'react-dom';
import './index.scss';
import { BrowserRouter } from 'react-router-dom';

import './assets/css/bootstrap.min.css';
import './assets/css/icons.css';
import './assets/css/metismenu.min.css';
import './assets/css/style.css';

import { unregister } from './registerServiceWorker';

import App from './App';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from 'assets/customisedMUI/theme';

//redux
import { Provider } from 'react-redux';

import store from './store/';

/* 
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
let stripePromise = '';

if (window.location.href.indexOf('/shop/test') > -1) {
    stripePromise = loadStripe('pk_test_ZtLZDgTm2sjPrRUWmRzsxmRC');
} else {
    stripePromise = loadStripe('pk_live_mamkS6FszqmKUBGd11CMFXFa');
}
 */
const app = (
    <Provider store={store}>
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </BrowserRouter>
    </Provider>
);

render(app, document.getElementById('root'));
unregister();
